import { createContext, useCallback, useMemo, useState } from "react";

const DEFAULT_STATE = {
  kind: null,
  mode: "append",
  targetSlug: null,
  existingSchema: null,
  file: null,
  dataJobId: null,
  parseResult: null,
  mapping: null,
  targetDisplayName: null,
  targetSingularName: null,
  targetIconName: null,
  targetDescription: null,
};

export const ImportTargetContext = createContext({
  ...DEFAULT_STATE,
  setKind: () => {},
  setMode: () => {},
  setTargetSlug: () => {},
  setExistingSchema: () => {},
  setFile: () => {},
  setDataJobId: () => {},
  setParseResult: () => {},
  setMapping: () => {},
  setTargetDisplayName: () => {},
  setTargetSingularName: () => {},
  setTargetIconName: () => {},
  setTargetDescription: () => {},
  reset: () => {},
});

export const ImportTargetProvider = ({ children, initialMode }) => {
  const [kind, setKind] = useState(DEFAULT_STATE.kind);
  const [mode, setMode] = useState(initialMode ?? DEFAULT_STATE.mode);
  const [targetSlug, setTargetSlug] = useState(DEFAULT_STATE.targetSlug);
  const [existingSchema, setExistingSchema] = useState(
    DEFAULT_STATE.existingSchema
  );
  const [file, setFile] = useState(DEFAULT_STATE.file);
  const [dataJobId, setDataJobId] = useState(DEFAULT_STATE.dataJobId);
  const [parseResult, setParseResult] = useState(DEFAULT_STATE.parseResult);
  const [mapping, setMapping] = useState(DEFAULT_STATE.mapping);
  const [targetDisplayName, setTargetDisplayName] = useState(
    DEFAULT_STATE.targetDisplayName
  );
  const [targetSingularName, setTargetSingularName] = useState(
    DEFAULT_STATE.targetSingularName
  );
  const [targetIconName, setTargetIconName] = useState(
    DEFAULT_STATE.targetIconName
  );
  const [targetDescription, setTargetDescription] = useState(
    DEFAULT_STATE.targetDescription
  );

  const reset = useCallback(() => {
    setKind(DEFAULT_STATE.kind);
    setMode(DEFAULT_STATE.mode);
    setTargetSlug(DEFAULT_STATE.targetSlug);
    setExistingSchema(DEFAULT_STATE.existingSchema);
    setFile(DEFAULT_STATE.file);
    setDataJobId(DEFAULT_STATE.dataJobId);
    setParseResult(DEFAULT_STATE.parseResult);
    setMapping(DEFAULT_STATE.mapping);
    setTargetDisplayName(DEFAULT_STATE.targetDisplayName);
    setTargetSingularName(DEFAULT_STATE.targetSingularName);
    setTargetIconName(DEFAULT_STATE.targetIconName);
    setTargetDescription(DEFAULT_STATE.targetDescription);
  }, []);

  const value = useMemo(
    () => ({
      kind,
      mode,
      targetSlug,
      existingSchema,
      file,
      dataJobId,
      parseResult,
      mapping,
      targetDisplayName,
      targetSingularName,
      targetIconName,
      targetDescription,
      setKind,
      setMode,
      setTargetSlug,
      setExistingSchema,
      setFile,
      setDataJobId,
      setParseResult,
      setMapping,
      setTargetDisplayName,
      setTargetSingularName,
      setTargetIconName,
      setTargetDescription,
      reset,
    }),
    [
      kind,
      mode,
      targetSlug,
      existingSchema,
      file,
      dataJobId,
      parseResult,
      mapping,
      targetDisplayName,
      targetSingularName,
      targetIconName,
      targetDescription,
      reset,
    ]
  );

  return (
    <ImportTargetContext.Provider value={value}>
      {children}
    </ImportTargetContext.Provider>
  );
};
